export default {
    notifications: {
        watched: {
            title: 'Recently watched class',
            body: 'Recently watched meditation '
        },
        timer: {
            title: 'Recently used Timer'
        },
        goal_watch_total: {
            title: 'Meditations Goal Achieved',
            goal_3:
                'You’ve watched 3 meditations. You are on your way to a wonderful practice! We are so happy to help you live a less stressed, more mindful life.',
            goal_10:
                'You’ve watched 10 meditations. Great job! Keep up the practice for a less stressed + more mindful life.',
            goal_30:
                'You’ve watched 30 meditations. Well done! Small shifts in your daily routine can add up to big + positive changes.',
            goal_50:
                'You’ve watched 50 meditations!  A few minutes each day helps to lower stress + anxiety and improve sleep.',
            goal_100:
                'You’ve watched 100 meditations!  Did you know meditation is a great option for restoring your physical energy? It’s great for the mind and the body!',
            goal_200:
                'You’ve watched 200 meditations!  With each practice, you’re improving your memory, focus + attention span.',
            goal_500:
                'You’ve watched 500 meditations!  Did you know meditation improves our emotional intelligence, helping us be more compassionate?  Great work!',
            goal_1000:
                'You’ve watched 1000 meditations. You’ve come so far + we’re so glad to have you as part of the CHILL family!'
        },
        goal_watch: {
            title: 'Minutes Goal Achieved',
            goal_30:
                'You’ve meditated for 30 minutes. You are on your way to a wonderful practice! We are so happy to help you live a less stressed, more mindful life.',
            goal_50:
                'You’ve meditated for 50 minutes. Great job! Keep up the practice for a less stressed + more mindful life.',
            goal_100:
                'You’ve meditated for 100 minutes. Great job! Keep up the practice for a less stressed + more mindful life.',
            goal_500:
                'You’ve meditated for 500 minutes. Well done! Small shifts in your daily routine can add up to big + positive changes.',
            goal_1000:
                'You’ve meditated for 1000 minutes!  A few minutes each day helps to lower stress + anxiety and improve sleep.',
            goal_2000:
                'You’ve meditated for 2000 minutes!  Did you know meditation is a great option for restoring your physical energy? It’s great for the mind and the body!',
            goal_3000:
                'You’ve meditated for 3000 minutes!  With each practice, you’re improving your memory, focus + attention span.',
            goal_4000:
                'You’ve meditated for 4000 minutes!  Did you know meditation improves our emotional intelligence, helping us be more compassionate?  Great work!',
            goal_5000:
                'You’ve meditated for 5000 minutes. You’ve come so far + we’re so glad to have you as part of the CHILL family!'
        },
        goal_daily_watch: {
            title: 'Days Streak Goal Achieved',
            goal_3:
                'You meditated for three days in a row. You are on your way to a wonderful practice! We are so happy to help you live a less stressed, more mindful life.',
            goal_5:
                'You’ve meditated for five days in a row. Great job! Keep up the practice for a less stressed + more mindful life.',
            goal_10:
                'You’ve meditated for ten days in a row. Well done! Small shifts in your daily routine can add up to big + positive changes.',
            goal_20:
                'You’ve meditated 20 days in a row!  Did you know meditation is a great option for restoring your physical energy? It’s great for the mind and the body!',
            goal_30:
                'You’ve meditated for 30 days in a row!  With each practice, you’re improving your memory, focus + attention span.',
            goal_50:
                'You’ve meditated for 50 days in a row!  Did you know meditation improves our emotional intelligence, helping us be more compassionate?  Great work!',
            goal_100:
                'You’ve meditated for 100 days in a row! You’ve come so far + we’re so glad to have you as part of the CHILL family!',
            goal_365:
                'Congratulations! You’ve meditated every day for a year. Your commitment to your practice is inspiring!'
        }
    }
};
